<template>
  <div class="ce-upload fix">
    <div class="fl ce-upload-name" :class="{'isBlue':fileList.length>0}">
      <span v-if="fileList.length==0">请上传55K~1M以内JPG格式的证书图片。</span>
      <a v-else :href="file.fileURL" target="_blank">{{file.fileName}}</a>
    </div>
    <el-upload
      class="fl"
      :action="uploadURL"
      :headers="{ 'X-Requested-With': 'XMLHttpRequest' }"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      name="file"
      :with-credentials="true"
      :show-file-list="false"
      :limit="limit"
      :on-remove="uploadRemove"
      :before-upload="beforeUpload"
      :file-list="fileList"
    >
      <el-button size="small" class="fl ce-primary-btn" type="primary">上传证书</el-button>
    </el-upload>
  </div>
</template>
<script>
export default {
  props: {
    limit: {
      required: true
    },
    placeholder: {
      default: ""
    }
  },
  created() {
    this.file.name = this.placeholder;
  },
  data() {
    return {
      uploadURL: __shopURL + "/security/file/upload/domain",
      fileList: [],
      file: {
        name: "",
        url: ""
      }
    };
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      this.fileList = [response.data.ftpFileVo];
      this.file = response.data.ftpFileVo;
      this.$emit("success", response.data.ftpFileVo);
    },
    uploadError(err, file, fileList) {},
    uploadRemove(file, fileList) {
      this.fileList = [];
      this.$emit("success", "");
    },
    beforeUpload(file) {
      console.log(file, "feile");

      if (file.type != "image/jpeg") {
        this.$msgbox({
          type: "error",
          message: "请上传55K~1M以内JPG格式的证书图片"
        });
        return false;
      }
      if (file.size > 1048576 || file.size < 56320) {
        this.$msgbox({
          type: "error",
          message: "请上传55K~1M以内JPG格式的证书图片"
        });
        return false;
      }
      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ce-upload.vue